import JetSegmentedControl from '@src/shared/components/JetSegmentedControl';
import React from 'react';
import { PAGE_TYPE } from '../../index';
import useStyles from './styles';
import JetFontIcon, {
  JET_FONTICON_ALIASES,
} from '@src/shared/components/JetFontIcon';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
const PageTypeSwitchContent = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation()
  const managerOption = (
    <div>
      <JetFontIcon
        className={`segmentIcon ${props.pageType === PAGE_TYPE.MANAGER ? 'selected' : ''}`}
        iconname={JET_FONTICON_ALIASES.MANAGEMENT}
        size={15}
      />{' '}
      {t('new_productoverview_common.section4_manager_selection')}
    </div>
  );
  const courierOption = (
    <div>
      <JetFontIcon
        className={`segmentIcon ${props.pageType === PAGE_TYPE.COURIER ? 'selected' : ''}`}
        iconname={JET_FONTICON_ALIASES.BIKE_SMALL}
        size={15}
      />{' '}
      {t('new_productoverview_common.section4_courier_selection')}
    </div>
  );
  return (
    <div className={classes.pageTypeSwitchContent}>
      <Typography
                  variant="body1"
                  className="body_regular switch-description"
                  align="center"
                >
                  <b>
                  {t('new_productoverview_common.section4_title')}
                  </b>
                </Typography>
      <div className="segmented-control-container">
        <JetSegmentedControl
          titles={[managerOption, courierOption]}
          values={[PAGE_TYPE.MANAGER, PAGE_TYPE.COURIER]}
          onSelected={props.onPageTypeChanged}
          model={props.pageType}
        />
      </div>
    </div>
  );
};
export default PageTypeSwitchContent;
